import { Keypair } from '@solana/web3.js';
import { ethers } from 'ethers';
import { useLocalStorage } from 'usehooks-ts';
import { toast } from 'sonner';
import bs58 from 'bs58';
import { useRouter } from 'next/router';
import crypto from 'crypto';
import { useSession } from '@/contexts/LitSessionProvider';
export default function useGetWrappedWallet() {
  const {
    clearLitSession
  } = useSession();
  const [startDecryption] = useLocalStorage('startDecryption', false);
  const [litCachedMinSig, setLitCachedMinSig] = useLocalStorage('genius-lit-cached-min-sig', null);
  const [decryptionSignature] = useLocalStorage('genius-decryption-signature', null);
  const [cipher1, setCipher1] = useLocalStorage('cipher1', null);
  const [cipher2, setCipher2] = useLocalStorage('cipher2', null);
  const router = useRouter();
  const getEVMWallet = async () => {
    var _a;
    if (startDecryption && (!litCachedMinSig || !decryptionSignature || !cipher1 || !cipher2)) {
      toast.info(`You're account is still being set up. Please wait a moment.`);
      return null;
    }
    try {
      const evmWalletLC = cipher1;
      if (!evmWalletLC) {
        throw new Error('No EVM wallet found');
        return null;
      } else {
        const encryptionSig = (_a = litCachedMinSig || decryptionSignature) === null || _a === void 0 ? void 0 : _a.slice(3, 35);
        const decryptedPrivateKey = decrypt(evmWalletLC, encryptionSig);
        const wallet = new ethers.Wallet(decryptedPrivateKey);
        return wallet;
      }
    } catch (error) {
      console.log('WUJI getEVMWallet error', error);
      clearLitSession();
      router.push(`/home?message=Your session has expired. You've been logged out to keep your account secure....`);
    }
  };
  const getSolanaWallet = async () => {
    var _a;
    if (startDecryption && (!litCachedMinSig || !decryptionSignature || !cipher1 || !cipher2)) {
      toast.info(`You're account is still being set up. Please wait a moment.`);
      return null;
    }
    try {
      const solanaWalletLC = cipher2;
      if (!solanaWalletLC) {
        throw new Error('No Solana wallet found');
        return null;
      } else {
        const encryptionSig = (_a = litCachedMinSig || decryptionSignature) === null || _a === void 0 ? void 0 : _a.slice(3, 35);
        const decryptedPrivateKey = decrypt(solanaWalletLC, encryptionSig);
        const keypair = Keypair.fromSecretKey(bs58.decode(decryptedPrivateKey));
        return keypair;
      }
    } catch (error) {
      console.error('[getSolanaWallet]', error);
      clearLitSession();
      router.push(`/home?message=Your session has expired. You've been logged out to keep your account secure...`);
    }
  };
  return {
    getEVMWallet,
    getSolanaWallet,
    litCachedMinSig,
    setLitCachedMinSig,
    cipher1,
    setCipher1,
    cipher2,
    setCipher2
  };
}
const algorithm = 'aes-256-ctr';
export const encrypt = (text, secretKey) => {
  const iv = crypto.randomBytes(16);
  const cipher = crypto.createCipheriv(algorithm, secretKey, iv);
  const encrypted = Buffer.concat([cipher.update(text), cipher.final()]);
  return {
    iv: iv === null || iv === void 0 ? void 0 : iv.toString('hex'),
    content: encrypted === null || encrypted === void 0 ? void 0 : encrypted.toString('hex')
  };
};
export const decrypt = (hash, secretKey) => {
  const decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(hash.iv, 'hex'));
  const decrpyted = Buffer.concat([decipher.update(Buffer.from(hash.content, 'hex')), decipher.final()]);
  return decrpyted === null || decrpyted === void 0 ? void 0 : decrpyted.toString();
};